import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { KnowledgeBlockModalTemplate as template } from './knowledge-block-modal.template';
import { KnowledgeBlockModalStyles as styles } from './knowledge-block-modal.styles';
import { RightSideModal } from '../../right-side-modal/right-side-modal';
import { IRightMenuService } from '../../../services/right-menu.service';
import { INavigationService } from '../../../services/navigation.service';
import { RoutePath } from '../../../utils';

const name = 'knowledge-block-modal';

enum MODAL_TITLES {
    MARKET_DEPTH = 'Market Depth',
    SELLER_DASHBOARD = 'Seller Dashboard',
    SELLER_ANALYTICS = 'Seller Analytics',
    EXECUTION = 'Execution',
    BUYER_DASHBOARD = 'Buyer Dashboard',
    BUYER_ANALYTICS = 'Buyer Analytics',
}

@customElement({
  name,
  template,
  styles,
})
export class KnowledgeBlockModal extends FASTElement {
  @observable knowledgeBlockModal: RightSideModal;
  @IRightMenuService rightMenuService: IRightMenuService;
  @INavigationService navigationService: INavigationService;

  // Modal config variables
  @observable show: boolean = false;
  @observable currentPath: string = '';
  @observable title = '';
  @observable width: string = '662px';

  private notifier: any;
  private handler: any;

  connectedCallback() {
    super.connectedCallback();
    this.showModalListener();
    this.navigationChangedListener();
    this.getCurrentPath();
    this.setTitle();
  }

  private getCurrentPath() {
    // on first load, an event will be sent before the listener is set up so we need to get the current path once the component is connected
    this.currentPath = this.navigationService.getCurrentPath();
  }

  private setTitle() {
    switch (this.currentPath) {
      case RoutePath.MARKET_DEPTH:
        this.title = MODAL_TITLES.MARKET_DEPTH;
        break;
      case RoutePath.SELLER_DASHBOARD:
        this.title = MODAL_TITLES.SELLER_DASHBOARD;
        break;
      case RoutePath.BUYER_DASHBOARD:
        this.title = MODAL_TITLES.BUYER_DASHBOARD;
        break;
      case RoutePath.SELLER_ANALYTICS:
        this.title = MODAL_TITLES.SELLER_ANALYTICS;
        break;
      case RoutePath.BUYER_ANALYTICS:
        this.title = MODAL_TITLES.BUYER_ANALYTICS;
        break;
      case RoutePath.EXECUTION:
        this.title = MODAL_TITLES.EXECUTION;
        break;
      default:
        this.title = 'Glossary';
        break;
    }
  }

  private showModalListener() {
    const _this = this;
    this.notifier = Observable.getNotifier(this.rightMenuService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        _this.show = source.knowledgeBlockVisibility;
      },
    };
    this.notifier.subscribe(this.handler, 'knowledgeBlockVisibility');
  }

  private navigationChangedListener() {
    const _this = this;
    this.notifier = Observable.getNotifier(this.navigationService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        _this.currentPath = source.currentPath;
        _this.setTitle();
      },
    };
    this.notifier.subscribe(this.handler, 'currentPath');
  }

  public closeModal() {
    this.rightMenuService.closeKnowledgeBlockModal();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.rightMenuService.closeKnowledgeBlockModal();
  }
}
